"use strict";

// "use strict";

jQuery(function ($) {
  if ($('.lottie-container').length) {
    window.ambr_lottie_run = function (entry) {
      // Set the path to your Lottie animation JSON file
      var animationPath = $(entry.target).data('src');
      // console.log(animationPath);
      var element = $(entry.target).attr('id');
      // console.log(element);
      lottie.loadAnimation({
        container: document.getElementById(element),
        // the dom element that will contain the animation
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: animationPath // the path to the animation json
      });
    };
    var script_file_URL = "".concat(ajax_resources.theme_path, "/assets/js/lottie.js");

    // Check if the Lottie is loaded on the page
    var load_lottie_scripts = $('script[src="' + script_file_URL + '"]').length;

    // Set inital stat to false once loaded will be set to true to stop loaing scripts more than once 
    var load_lottie_scripts_check = false;
    var icons = document.querySelectorAll('.lottie-container');
    if ('IntersectionObserver' in window) {
      var handleIntersectionLotties = function handleIntersectionLotties(entries) {
        entries.map(function (entry) {
          if (entry.isIntersecting) {
            // https://www.educative.io/answers/how-to-dynamically-load-a-js-file-in-javascript
            if (script_file_URL && !load_lottie_scripts_check) {
              if (load_lottie_scripts === 0) {
                var scriptEle = document.createElement("script");
                scriptEle.setAttribute("type", "text/javascript");
                scriptEle.setAttribute("src", script_file_URL);
                scriptEle.setAttribute("async", true);
                document.body.appendChild(scriptEle);
                scriptEle.addEventListener("load", function () {
                  // console.log("Carousel Script Loaded");
                  ambr_lottie_run(entry);
                });
                scriptEle.addEventListener("error", function (ev) {
                  console.log("Error on loading file", ev);
                });
              }
              // Set to true to stop loading script again
              load_lottie_scripts_check = true;
              // observer.unobserve(entry.target);
            } else {
              console.log(load_lottie_scripts);
              // console.log("carousel JS already loaded"); 
              $.getScript(script_file_URL, function () {
                ambr_lottie_run(entry);
              });
            }
            observer.unobserve(entry.target);
          }
        });
      };
      var observer = new IntersectionObserver(handleIntersectionLotties);
      icons.forEach(function (icon) {
        return observer.observe(icon);
      });
    } else {
      console.log('Please use a modern browser!');
      // <Fallback Logic Here>
    }
  }
});